// add custom filters
var sorfilterHTML = `

    <div class="row" style="margin-top: 0px !important;">
    <div id="columnVisabilityContainer" class="col-sm-4 col-md-2" style="margin-top:22px">
    </div>

      <div class="form-group col-sm-4 offset-sm-1">
      <label for="rSwitch" style="clear:both;" class="form-control-label">Reconcile Order </label><br>

        <label class="switch switch-lg switch-text switch-pill switch-danger" style="clear:both;">
          <input type="checkbox"  class="switch-input" id="rSwitch"></input>
          <span class="switch-label" data-on="On" data-off="Off"></span>
          <span class="switch-handle"></span>
        </label>
        </label>
        <div class="small text-muted">(Disables Refresh)</div>
      </div>


      <div class="form-group col-sm-3 offset-sm-1">

      <label for="orderStatusFilter">Order Status Filter</label>
      <select class="form-control form-control-sm"
      style="margin-left: 0.5em; margin-right:1em;display:inline-block;" id="orderStatusFilter"
      placeholder="Filter Order Status">
        <option value="">All</option>
        <option value="open">Open</option>
        <option value="error">Error</option>
        <option value="closed">Closed</option>
        <option value="rejected">Rejected</option>
        <option value="cancelled">Cancelled</option>
      </select>
      </div>

      <!--
      <div class="form-group col-sm-4">

        <label for="sorOrderSearch">Search</label>
        <input type="search" id="sorOrderSearch" class="form-control form-control-sm"
        placeholder="" aria-controls="sorOrders">
      </div>
      -->
     </div>
    `


// gobal variables
var pageScrollPos = 0;


class SorOrderTable extends DataTable {

  constructor(order, table_id) {


    super(table_id, false);
    this.order = order;

    this.setupTable();

    this.setupFilters();

  }
  ordering() {
    return [[ 1, "desc" ]]
  }

  rowCallback(row, data) {
    if (data.exchange_status=="error") {
      if (data.exchange_error_ack) {
        $(row).addClass('table-warning');
      } else {
        $(row).addClass('table-danger');
      }
    } else if (data.exchange_status=="rejected") {
      $(row).addClass('table-warning');
    }
  }

  getTableColumns() {
    var columnArray = [
                { "data": "exchange" },
                { "data": "created_at",
                  "render": function(data, type, row) {
                    if (type === 'sort') {
                      return data
                    }
                    if(data) {
                        return moment(data).format('llll');
                      }
                    return moment(row.exchange_timestamp).format('llll');
                  }},
                { "data": "quantity",
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(6))
                  }},
                { "data": "exchange_engine_order_id" },
                { "data": "limit_price",
                  "render": function(data, type, row) {
                    return Number(parseFloat(data).toFixed(8))
                  } },
                { "data": "exchange_filled_qty",
                    "render": function(data, type, row) {
                      return Number(parseFloat(data).toFixed(6))
                    } },
                { "data": "exchange_filled_fee" },
                { "data": "exchange_fee_currency" },
                { "data": "net_executed_quantity" },
                { "data": "exchange_executed_avg_price",
                    "render": function(data, type, row) {
                      return Number(parseFloat(data).toFixed(6))
                    }},
                { "data": "net_consideration" },
                { "data": "exchange_status",
                    "name": "order_status",
                    "render": function(data, type, row) {
                      var response = Handlebars.templates['orders/sor_detail_status.html'](row);
                      return response
                    }},
                { "data": "order_type", "name": "order_type" }

            ]

            // if (this.order.end_time) {
            //   columnArray.push({ "data": "order_type", "name": "order_type" })
            // }
            return columnArray
          }

  _getTableAjax() {
    return {
      url: '/api/client_orders/' + this.order.client_order_id + '/sor_orders/',
      type: 'GET',
      dataSrc: ''
    }
  }



  // adds filters to the dom and sets up event handlers and state
  setupFilters() {
    console.log("setting up filters");
    this.addOrderFilters(sorfilterHTML);
    // Reconsile mode switch
    this.enableSORRefresh = true;
    var self = this;
    $('#rSwitch').on('change', function() {
      if (this.checked) {
        $('#orderStatusFilter').val('error');
        $('#orderStatusFilter').change();
        self.enableSORRefresh = false;
        if (self.order.end_time) {
          self.table.column('order_type:name').visible(false).adjust().draw(null, false);
        }
      } else {
        $('#orderStatusFilter').val(null);
        $('#orderStatusFilter').change();
        self.enableSORRefresh=true;
        if (self.order.end_time) {
          self.table.column('order_type:name').visible(true).adjust().draw(null, false);
        }
      }
    });


  }

  refresh(force) {
    if(this.enableSORRefresh || force) {
      this.table.ajax.reload( null, false );

    } else {
      console.log("not refreshing")
    }

  }




}
